<template>
  <div class="gs-app gm-starting-rules">
    <div class="flex flex-no-wrap flex-col">
      <div class="mb-6">
        <gd-tabs
          :tabs="startRuleTabs"
          :currentTab="currentStartRulesTab"
          :wrapper-class="'gs-default-tabs'"
          :tab-class="mainTabClass"
          :tab-active-class="
            'p-2 border-primary border-b-2 text-primary gs-default-tabs-item-active'
          "
          :line-class="'gs-default-tabs-active-line'"
          @onClick="handleStartRuleTabChange"
        />
      </div>
      <div class="step1 mb-6" v-if="currentStartRulesTab === 'tag'">
        <p class="font-semibold text-base text-dark mb-2">
          {{ $t('frontend_groovemail_sequences_startingrules_tags') }}
        </p>
        <div class="flex flex-no-wrap flex-col">
          <div class="w-full mb-2 relative">
            <DownIcon class="h-5 w-5 absolute right-2 text-grey-600 top-2.5"/>
            <select
              @change="onChangecategory($event)"
              v-model="localModel.category"
              class="w-full h-10 rounded-lg text-sm border border-grey-200 text-dark bg-white pl-3 pr-7 appearance-none"
            >
              <option value>
                {{ $t('frontend_groovemail_sequences_splitnode_select_category') }}
              </option>
              <option
                v-for="category in this.categories"
                :value="category.id"
                :key="category.id"
              >
                {{ category.name }}
              </option>
            </select>
          </div>
          <div class="w-full relative">
            <DownIcon class="h-5 w-5 absolute right-2 text-grey-600 top-2.5"/>
            <select
              @change="onChangetag($event)"
              v-model="localModel.tag"
              class="w-full h-10 rounded-lg text-sm border border-grey-200 text-dark bg-white pl-3 pr-7 appearance-none"
              :disabled="this.tagdisabled"
              v-bind:class="{ disabled: this.tagdisabled }"
            >
              <option value>
                {{ $t('frontend_groovemail_sequences_splitnode_select_tag') }}
              </option>
              <option
                v-for="tag in this.tags"
                :value="tag.id"
                :data-name="tag.name"
                :key="tag.id"
              >
                {{ tag.name }}
              </option>
            </select>
          </div>
          <div
            class="text-primary text-sm flex items-center font-semibold cursor-pointer mt-2"
            @click="createNewTag"
          >
            <PlusIcon class="h-5 w-5"/>
            <p>{{ $t('frontend_groovemail_contacts_step4_create_newtag') }}</p>
          </div>
        </div>

        <div class="flex w-full">
          <div class="text-center w-full flex flex-row flex-wrap">
            <p
              class="
                list-chip
                font-thin
                leading-8
                border-0
                text-primary-invert bg-primary
                mt-2
                mr-2
                relative
              "
              v-for="(option, index) in this.localModel.assignedtags"
              :key="index"
            >
              <span class="pl-2">
                {{ $t('frontend_groovemail_sequences_startingrules_leadis') }}
              </span>
              <span class="text-xs font-semibold pl-2 pr-2">
                {{ option.name }}
              </span>
              <span @click="deletetag(option)" class="px-2 gm-starting-rules-remove">
                <span style="cursor: pointer" class="fa text-xs cross-chip"
                  >&#xf00d;</span
                >
              </span>
            </p>
          </div>
        </div>
      </div>
      <div class="mb-6" v-if="currentStartRulesTab === 'list'">
        <p class="font-semibold text-base text-dark mb-2">
          {{ $t('frontend_groovemail_sequences_startingrules_lists') }}
        </p>
        <div class="flex flex-no-wrap flex-col">
          <div class="w-full relative">
            <DownIcon class="h-5 w-5 absolute right-2 text-grey-600 top-2.5"/>
            <select
              @change="onChangelist($event)"
              v-model="localModel.list"
              class="w-full h-10 rounded-lg text-sm border border-grey-200 text-dark bg-white pl-3 pr-7 appearance-none"
            >
              <option value>
                {{ $t('frontend_groovemail_sequences_startingrules_select_list') }}
              </option>
              <option
                v-for="(list, index) in this.lists"
                :value="list.id"
                :data-name="list.name"
                :key="index"
              >
                {{ list.name }}
              </option>
            </select>
          </div>
        </div>
        <div
          class="text-primary text-sm flex items-center font-semibold cursor-pointer mt-2"
          @click="createNewList"
        >
          <PlusIcon class="h-5 w-5"/>
          <p>{{ $t('frontend_groovemail_contacts_step4_create_new_list') }}</p>
        </div>
        <div class="text-center w-full flex flex-row flex-wrap">
          <div class="text-left">
            <p
              class="
                list-chip
                font-thin
                leading-8
                border-0
                text-primary-invert bg-primary
                mt-2
                mr-2
                relative
              "
              v-for="option in this.localModel.subscribedlists"
              :key="option.id"
            >
              <span class="pl-2">
                {{ $t('frontend_groovemail_sequences_startingrules_lead_subscribers') }}
              </span>
              <span class="text-xs font-semibold pl-2 pr-2">
                {{option.name}}
              </span>
              <span @click="deletelist(option)" class="px-2 gm-starting-rules-remove">
                <span style="cursor: pointer" class="fa text-xs cross-chip"
                  >&#xf00d;</span
                >
              </span>
            </p>
          </div>
        </div>
      </div>
      <div class="mb-6" v-if="currentStartRulesTab === 'form'">
        <p class="font-semibold text-base text-dark mb-2">
          {{ $t('frontend_groovemail_sequences_startingrules_forms') }}
        </p>
        <div class="flex flex-no-wrap flex-col">
          <div class="w-full relative">
            <DownIcon class="h-5 w-5 absolute right-2 text-grey-600 top-2.5"/>
            <select
              @change="onChangeform($event)"
              v-model="localModel.form"
              class="w-full h-10 rounded-lg text-sm border border-grey-200 text-dark bg-white pl-3 pr-7 appearance-none"
            >
              <option value>
                {{ $t('frontend_groovemail_sequences_startingrules_select_form') }}
              </option>
              <option
                v-for="(form, index) in this.forms"
                :value="form.id"
                :data-name="form.name"
                :key="index"
              >
                {{ form.name }}
              </option>
            </select>
          </div>
        </div>

        <div class="text-center w-full flex flex-row flex-wrap">
          <div class="text-left">
            <!-- <p @click="deletelist(option)" class="text-md text-grey-600" v-for="option in this.localModel.subscribedlists" v-html="option"> </p> -->
            <p
              class="
                list-chip
                font-thin
                leading-8
                border-0
                text-primary-invert bg-primary
                mt-2
                mr-2
                relative
              "
              v-for="option in this.localModel.subscribedforms"
              :key="option.id"
            >
              <span class="pl-2">
                {{ $t('frontend_groovemail_sequences_startingrules_lead_subscribes_to') }}
              </span>
              <span class="text-xs font-semibold pl-2 pr-2">
                {{ option.name }}
              </span>
              <span @click="deleteform(option)" class="px-2 gm-starting-rules-remove">
                <span style="cursor: pointer" class="fa text-xs cross-chip"
                  >&#xf00d;</span
                >
              </span>
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Notify from '@groovepages/gd-ui-kit/notify';
import axios from 'axios';
import Category from '@/models/Category';
import Mailform from '@/models/Mailform';


// import icons
import PlusIcon from '@/assets/images/icons/new/plus-small_new.svg';
import DownIcon from '@/assets/images/icons/new/down_new.svg';

export default {
  name: 'StartingRules',
  props: {
    model: {
      required: true,
    },
  },

  data() {
    return {
      currentStartRulesTab: 'tag',
      localModel: this.model,
      lists: [],
      categories: [],
      tags: [],
      forms: [],
      addbtndisabled: true,
      tagdisabled: true,
      listname: '',
      tagname: '',
      formname: '',
    };
  },

  components: {
    PlusIcon,
    DownIcon,
  },

  methods: {
    createNewTag() {
      this.$emit('createNewTag', 1);
    },

    createNewList() {
      this.$emit('createNewList', 1);
    },

    async updateListData(lists) {
      const mailLists = await axios.get(`/maillistonly`);
      this.lists = mailLists?.data?.data;
      if (lists && lists.data) {
        this.localModel.subscribedlists.push({
          name: lists.data.name,
          id: lists.data.id,
        });
      }
    },

    async updateTagData(tags) {
      this.categories = await Category.$get();
      if (tags && tags.data) {
        this.localModel.assignedtags.push({
          name: tags.data.name,
          id: tags.data.id,
        });
      }
    },

    handleStartRuleTabChange(newTab) {
      this.currentStartRulesTab = newTab;
    },

    addtag() {
      this.localModel.assignedtags.push({
        name: this.tagname,
        id: this.localModel.tag,
      });
      this.tags = [];
      this.localModel.tag = '';
      this.localModel.category = '';
    },

    addlist() {
      this.localModel.subscribedlists.push({
        name: this.listname,
        id: this.localModel.list,
      });
      this.listname = '';
      this.localModel.list = '';
    },

    addform() {
      if (this.forms && this.forms.length) {
        const currentFormData = this.forms.find((ele) => ele.id === this.localModel.form);
        const currentFormFields = JSON.parse(currentFormData.form_fields);
        let phoneNumberField;
        if (currentFormFields && currentFormFields.fields) {
          phoneNumberField = currentFormFields.fields.find((ele) => ele.name === 'phone_number');
        } else {
          phoneNumberField = currentFormFields.find((ele) => ele.name === 'phone_number');
        }
        if (phoneNumberField && !phoneNumberField.mandatory) {
          Notify.warn(
            this.$t('frontend_groovemail_forms_phone_number_field_mandatory_warning_message')
          );
        }
      }
      this.localModel.subscribedforms.push({
        name: this.formname,
        id: this.localModel.form,
      });
      this.formname = '';
      this.localModel.form = '';
    },

    showtab(option) {
      this.localModel.mainselect = option;
    },

    async onChangecategory(e) {
      const { data } = await axios.get('/mailtag', {
        params: { category: e.target.value },
      });
      if (data.length > 0) {
        this.tags = data;
        this.tagdisabled = false;
      } else {
        this.tagdisabled = true;
      }
    },

    deletetag(option) {
      const index = this.localModel.assignedtags.indexOf(option);
      this.localModel.assignedtags.splice(index, 1);

      const saverule = document.querySelector('#saverule');
      saverule.click();
    },

    deletelist(option) {
      const index = this.localModel.subscribedlists.indexOf(option);
      this.localModel.subscribedlists.splice(index, 1);

      const saverule = document.querySelector('#saverule');
      saverule.click();
    },

    deleteform(option) {
      const index = this.localModel.subscribedforms.indexOf(option);
      this.localModel.subscribedforms.splice(index, 1);

      const saverule = document.querySelector('#saverule');
      saverule.click();
    },

    saverule() {
      // console.log('yes');
    },

    onChangetag(e) {
      this.localModel.saverulebtn = true;
      this.addbtndisabled = false;
      this.tagname =
        e.target.options[e.target.options.selectedIndex].dataset.name;
      if (!this.localModel.assignedtags.includes(this.tagname)) {
        this.addtag();
      }
    },

    onChangelist(e) {
      this.localModel.saverulebtn = true;
      this.addbtndisabled = false;
      this.listname =
        e.target.options[e.target.options.selectedIndex].dataset.name;
      if (!this.localModel.subscribedlists.includes(this.listname)) {
        this.addlist();
      }
    },

    onChangeform(e) {
      this.localModel.saverulebtn = true;
      this.addbtndisabled = false;
      this.formname =
        e.target.options[e.target.options.selectedIndex].dataset.name;
      if (!this.localModel.subscribedforms.includes(this.formname)) {
        this.addform();
      }
    },
  },

  async created() {
    const mailLists = await axios.get(`/maillistonly`);
    this.lists = mailLists?.data?.data;
    this.categories = await Category.$get();
    this.forms = await Mailform.$get();
  },

  mounted() {
    this.localModel.assignedtags =
    typeof this.localModel.assignedtags === 'string'
      ? JSON.parse(this.localModel.assignedtags)
      : this.localModel.assignedtags
      ? this.localModel.assignedtags
      : [];
    
    this.localModel.subscribedlists =
      typeof this.localModel.subscribedlists === 'string'
        ? JSON.parse(this.localModel.subscribedlists)
        : this.localModel.subscribedlists
        ? this.localModel.subscribedlists
        : [];
    
    if (this.localModel.subscribedforms) {
      this.localModel.subscribedforms =
        typeof this.localModel.subscribedforms === 'string'
          ? JSON.parse(this.localModel.subscribedforms)
          : this.localModel.subscribedforms
          ? this.localModel.subscribedforms
          : [];
    } else {
      this.localModel.subscribedforms = [];
    }
  },

  watch: {
    localModel() {
      this.$emit('updateModel', this.localModel);
    },
  },

  computed: {
    startRuleTabs() {
      return [
        {
          title: `<span class="text-sm font-semibold px-4">${this.$t(
            'frontend_groovemail_sequences_startingrules_tags'
          )}</span>`,
          value: 'tag',
        },
        {
          title: `<span class="text-sm font-semibold px-4">${this.$t(
            'frontend_groovemail_sequences_startingrules_lists'
          )}</span>`,
          value: 'list',
        },
        {
          title: `<span class="text-sm font-semibold px-4">${this.$t(
            'frontend_groovemail_sequences_startingrules_forms'
          )}</span>`,
          value: 'form',
        },
      ];
    },

    mainTabClass() {
      return 'pb-4 gs-default-tabs-item';
    },
  },
};
</script>

<style lang="scss">
.start-border-grey-200 {
  border-color: #545671 !important;
}
</style>

<style scoped>
.gm-starting-rules {
  min-width: 0;
}

.gm-starting-rules select {
  min-height: 44px;
  height: 44px;
}

.gm-starting-rules ::v-deep .tabs {
  display: flex;
  gap: 4px;
  overflow-x: auto;
  scrollbar-width: thin;
}

.gm-starting-rules ::v-deep .tabs__item {
  display: inline-flex;
  align-items: center;
  min-height: 44px;
  min-width: 0;
  margin-right: 0;
  padding: 0 10px 8px;
  white-space: nowrap;
}

.gm-starting-rules .list-chip {
  display: inline-grid;
  grid-template-columns: minmax(0, 1fr) 44px;
  grid-template-rows: auto auto;
  align-items: center;
  min-height: 44px;
  max-width: 100%;
  margin: 8px 8px 0 0;
  text-align: left;
  color: var(--gs-foreground);
  background: var(--gs-muted);
  border: 1px solid var(--gs-border);
  border-radius: var(--gs-radius-md);
  overflow-wrap: anywhere;
}

.gm-starting-rules .list-chip > span:first-child {
  grid-column: 1;
  grid-row: 1;
  padding: 8px 0 0 12px;
  line-height: 1.35;
}

.gm-starting-rules .list-chip > span:nth-child(2) {
  grid-column: 1;
  grid-row: 2;
  padding: 0 0 8px 12px;
  line-height: 1.35;
}

.gm-starting-rules-remove {
  grid-column: 2;
  grid-row: 1 / span 2;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex: 0 0 44px;
  align-self: stretch;
  min-width: 44px;
  min-height: 44px;
  padding: 0;
  color: var(--gs-danger);
  cursor: pointer;
}

.gm-starting-rules .cross-chip {
  color: currentColor;
}

@media (max-width: 40rem) {
  .gm-starting-rules ::v-deep .tabs__item {
    padding-right: 8px;
    padding-left: 8px;
  }
}
</style>
